import React,{ useState, useEffect, useRef } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api, firebase } from 'common';
import { push } from 'firebase/database';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { Typography, Switch, Button, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, Badge, Tooltip, Checkbox, ListItemText, Box, Chip, OutlinedInput } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import {colors} from '../components/Theme/WebTheme';
import AlertDialog from '../components/AlertDialog';
import { useNavigate, useParams , useLocation  } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BlankTable from 'components/BlankTable';

const REJECTION_KEYS = [
  "reupload_id_front",
  "reupload_id_back",
  "reupload_license_front",
  "reupload_license_back",
  "reupload_photo_with_license",
  "reupload_police_clearance",
  "reupload_all_images"
];

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editUser, 
    revokeUserTokens,
    fetchUsersOnce,
    deleteUsersAllcars,
    removeChatWithUserDelete
  } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const navigate = useNavigate();
  const {id} = useParams()
  const {state} = useLocation();
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectDriver, setRejectDriver] = useState(null);
  const [rejectReasons, setRejectReasons] = useState([]);
  

  useEffect(()=>{
      dispatch(fetchUsersOnce());
  },[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers){
        if(role === 'admin' || role === 'subadmin'  ){
          let arr =  staticusers.filter(user => user.usertype==='fleetadmin');
          let obj = {}; 
          let arr2 = [];
          for(let i=0;i  < arr.length; i++){
              let user = arr[i];
              arr2.push({id: user.id, desc:user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden")});
              obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden");
          }
          setFleetAdminsObj(obj);
      } 
      setTimeout(()=>{
        setData(staticusers.filter(user => user.usertype ==='driver' && ((user.fleetadmin === auth.profile.uid && auth.profile.usertype === 'fleetadmin')|| auth.profile.usertype === 'admin'|| auth.profile.usertype === 'subadmin')).map(user => ({...user})));
      },1000);
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers,auth.profile.usertype,auth.profile.uid,settings.AllowCriticalEditsAdmin,role]);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handelApproved = (rowData, isApproving) => {
    if (isApproving) {
      if (!rowData.verifyIdImage || !rowData.verifyIdImageBack || !rowData.licenseImage || !rowData.licenseImageBack || !rowData.photoWithLicense || !rowData.policeClearance) {
        setCommonAlert({ open: true, msg: t('missing_documents_error') });
        return;
      }
      const updatedUser = { ...rowData, approved: isApproving, adminApprovedTrue: true, driverApproved: true, rejectionReason: "", hasNewDocUpload: false, docUpdated: false };
      dispatch(editUser(updatedUser.id, updatedUser));
      dispatch(fetchUsersOnce());
      if (rowData.id) {
        api.fetchSingleUser(rowData.id).then((user) => {
          const pushToken = user?.pushToken || rowData.pushToken;
          const title = t('account_approved_title') && t('account_approved_title') !== 'account_approved_title' ? t('account_approved_title') : 'Account Approved';
          const msg = t('account_approved_msg') && t('account_approved_msg') !== 'account_approved_msg' ? t('account_approved_msg') : 'Your account has been approved by admin.';
          if (pushToken) {
            api.RequestPushMsg(pushToken, {
              title: title,
              msg: msg,
              screen: 'DriverTrips',
              channelId: 'messages'
            });
          }
          if (firebase && firebase.userNotificationsRef) {
            try {
              push(firebase.userNotificationsRef(rowData.id), {
                dated: new Date().getTime(),
                title: title,
                msg: msg,
                screen: 'DriverTrips'
              });
            } catch (e) {
              console.error("Error writing user notification:", e);
            }
          }
        });
      }
      return updatedUser;
    } else {
      setRejectDriver(rowData);
      setRejectReasons([]);
      setRejectDialogOpen(true);
    }
  };

  const handleRejectAccount = () => {
    if (rejectDriver && rejectReasons.length > 0) {
      const reasonText = rejectReasons.join('\n');
      const updatedUser = { ...rejectDriver, approved: false, adminApprovedTrue: false, driverApproved: false, rejectionReason: reasonText, hasNewDocUpload: false, docUpdated: false };
      dispatch(editUser(updatedUser.id, updatedUser));
      dispatch(fetchUsersOnce());
      const driverId = rejectDriver.id;
      if (driverId) {
        api.fetchSingleUser(driverId).then((user) => {
          const pushToken = user?.pushToken || rejectDriver.pushToken;
          const title = t('account_rejected_title') && t('account_rejected_title') !== 'account_rejected_title' ? t('account_rejected_title') : 'Your Documents not approved.';
          const msg = rejectReasons.map(r => t(r, r)).join(', ');
          if (pushToken && reasonText) {
            api.RequestPushMsg(pushToken, {
              title: title,
              msg: msg,
              screen: 'editUser',
              channelId: 'messages'
            });
          }
          if (firebase && firebase.userNotificationsRef && reasonText) {
            try {
              push(firebase.userNotificationsRef(driverId), {
                dated: new Date().getTime(),
                title: title,
                msg: msg,
                screen: 'editUser'
              });
            } catch (e) {
              console.error("Error writing user notification:", e);
            }
          }
        });
      }
    }
    setRejectDialogOpen(false);
    setRejectDriver(null);
    setRejectReasons([]);
  };

  const handelDriverActiveStatus = (rowData) => {
    const updatedUser = {
      ...rowData,
      driverActiveStatus: !rowData.driverActiveStatus,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  
  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable: 'never', defaultSort: 'desc', render: rowData => rowData.createdAt ? moment(rowData.createdAt).format('lll') : null, },
    { title: t('first_name'), field: 'firstName', initialEditValue: '', },
    { title: t('last_name'), field: 'lastName', initialEditValue: '', },
    { title: t('mobile'), field: 'mobile', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo", },
    { title: t('email'), field: 'email', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo", headerStyle: { textAlign: 'center' } },
    { title: t('profile_image'), field: 'profile_image', render: rowData => rowData.profile_image ? <img alt='Profile' src={rowData.profile_image} style={{ width: 50, borderRadius: '50%' }} /> : <AccountCircleIcon sx={{ fontSize: 50 }} />, editable: 'never', },
    {
      title: t('account_approve'), field: 'approved', render: (rowData) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Button
            size="small"
            variant={rowData.approved ? "contained" : "outlined"}
            style={{ 
              backgroundColor: rowData.approved ? 'green' : 'transparent', 
              color: rowData.approved ? 'white' : 'green', 
              borderColor: 'green',
              textTransform: 'none',
              minWidth: '110px'
            }}
            disabled={!settings.AllowCriticalEditsAdmin}
            onClick={() => handelApproved(rowData, true)}
          >
            {t('approved') || 'Approved'}
          </Button>
          <Button
            size="small"
            variant={!rowData.approved ? "contained" : "outlined"}
            style={{ 
              backgroundColor: !rowData.approved ? 'red' : 'transparent', 
              color: !rowData.approved ? 'white' : 'red', 
              borderColor: 'red',
              textTransform: 'none',
              minWidth: '110px'
            }}
            disabled={!settings.AllowCriticalEditsAdmin}
            onClick={() => handelApproved(rowData, false)}
          >
            {t('not_approved') || 'Not approved'}
          </Button>
        </div>
      ),
    },
    {
      title: t('account_messages', 'Account Messages'),
      field: 'rejectionReason',
      render: (rowData) => {
        const isApproved = rowData.approved;
        const msg = rowData.rejectionReason;
        const hasNewUpload = rowData.hasNewDocUpload || rowData.docUpdated;

        if (isApproved || !msg) {
          return (
            <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
              {t('no_action_required', 'No action required')}
            </Typography>
          );
        }

        const reasons = Array.isArray(msg)
          ? msg.filter(Boolean)
          : typeof msg === 'string'
          ? msg.split('\n').map(s => s.trim()).filter(Boolean)
          : [msg];

        if (reasons.length === 0) {
          return (
            <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
              {t('no_action_required', 'No action required')}
            </Typography>
          );
        }

        const firstReason = t(reasons[0], reasons[0]);
        const fullTooltip = reasons.map((r, i) => `${i + 1}. ${t(r, r)}`).join('\n');

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, maxWidth: 220 }}>
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{reasons.length > 1 ? fullTooltip : firstReason}</span>} arrow placement="top">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                <Typography
                  variant="body2"
                  style={{
                    color: '#d32f2f',
                    fontWeight: 'bold',
                    fontSize: 12,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: reasons.length > 1 ? 140 : 200,
                    cursor: 'pointer'
                  }}
                >
                  {firstReason}
                </Typography>
                {reasons.length > 1 && (
                  <Chip
                    label={`+${reasons.length - 1}`}
                    size="small"
                    style={{
                      height: 20,
                      fontSize: 11,
                      backgroundColor: '#ffebee',
                      color: '#d32f2f',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  />
                )}
              </div>
            </Tooltip>
            {hasNewUpload && (
              <Tooltip title={t('new_document_uploaded', 'New document uploaded by driver')}>
                <Badge color="error" variant="dot">
                  <NotificationsActiveIcon style={{ color: '#ff9800', fontSize: 18 }} />
                </Badge>
              </Tooltip>
            )}
          </div>
        );
      }
    },
    {
      title: t('car_approval'), field: 'carApproved', type: 'boolean', render: (rowData) => (
        <Switch
          disabled={true}
          checked={rowData.carApproved}
        />
      ),
    },
    {
      title: t('driver_active'), field: 'driverActiveStatus', type: 'boolean', initialEditValue: true, render: (rowData) => (
        <Switch
          disabled
          checked={rowData.driverActiveStatus}
          onChange={() => handelDriverActiveStatus(rowData)}
        />
      ),
    },
    
    {
      title: t('queue'), field: 'queue', type: 'boolean', editable: 'never', render: (rowData) => (
        <Switch
          disabled
          checked={rowData.queue}
        />
      ),
    },
  ];

  
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
   
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };



  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(0); 

  useEffect(()=>{
   setCurrentPage(state?.pageNo)
  },[state])


const handlePaginationChange = (page) => {
  setCurrentPage(page)
};

const options={
  initialPage:state?.pageNo ||0,
  pageSize: 10,
  pageSizeOptions: [10, 15, 20],
  exportCsv: (columns, data) => {
    let hArray = [];
    const headerRow = columns.map(col => {
      if (typeof col.title === 'object') {
        return col.title.props.text;
      }
      hArray.push(col.field);
      return col.title;
    });
    const dataRows = data.map(({ tableData, ...row }) => {
      row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString();
      row.fleetadmin = row.fleetadmin?fleetAdminsObj[row.fleetadmin]:'';
      let dArr = [];
      for(let i=0;i< hArray.length; i++) {
        dArr.push(row[hArray[i]]);
      }
      return Object.values(dArr);
    })
    const { exportDelimiter } = ",";
    const delimiter = exportDelimiter ? exportDelimiter : ",";
    const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
    const csvFileName = 'download.csv';
    downloadCsv(csvContent, csvFileName);
  },
  exportButton: {
    csv: settings.AllowCriticalEditsAdmin,
    pdf: false,
  },
  maxColumnSort: "all_columns",
  rowStyle: rowData => ({
    backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
  }),
  editable:{
    backgroundColor: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: 'Lucida Console", "Courier New", monospace'
  },
  headerStyle: {
    position: "sticky",
    top: "0px",
    backgroundColor: colors.SECONDARY,
    color: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
  },
  cellStyle: {
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
  },
  actionsColumnIndex: -1,
}

const localization={body:{
  addTooltip: (t('add')),
  deleteTooltip: (t('delete')),
  editTooltip: (t('edit')),
  emptyDataSourceMessage: (
    (t('blank_message'))
),
editRow: { 
  deleteText: (t('delete_message')),
  cancelTooltip: (t('cancel')),
  saveTooltip: (t('save')) 
    }, 
  },
  toolbar: {
    searchPlaceholder: (t('search')),
    exportTitle: (t('export')),
  },
  header: {
    actions: (t('actions')) 
},
pagination: {
  labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
  firstTooltip: (t('first_page_tooltip')),
  previousTooltip: (t('previous_page_tooltip')),
  nextTooltip: (t('next_page_tooltip')),
  lastTooltip: (t('last_page_tooltip'))
},
}
  return (
    !loaded.current? <CircularLoading/>:
    <div style={{backgroundColor:colors.WHITE}}>
        {data && data.length > 0 ? 
    <MaterialTable
      title={t('drivers')}
      onChangePage={(page) => handlePaginationChange(page)}
      columns={columns}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', borderRadius: "8px", boxShadow: `4px 4px 6px ${colors.SECONDARY}`, }}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={options}
      localization={localization}
      editable={{
        onRowDelete: async (oldData) => {
          try{
            if (settings.AllowCriticalEditsAdmin) {
              await revokeUserTokens(oldData.id);
              await deleteUsersAllcars(oldData.id);
              await removeChatWithUserDelete(oldData.id);
              return new Promise((resolve) => {
                setTimeout(() => {
                  dispatch(fetchUsersOnce());
                  resolve();
                }, 600);
              });
            } else {
              return new Promise((resolve) => {
                setTimeout(() => {
                  setCommonAlert({ open: true, msg: t('demo_mode') });
                  resolve();
                }, 600);
              });
            }
          }catch(error){
            console.log("error in deletion", error);
          }
        },
      }}
      actions={[
        {
          icon: "add",
          tooltip: t("add_driver"),
          isFreeAction: true,
          onClick: (event) => 
          navigate( `/users/adddriver`,  { state: { pageNo: currentPage }} )
        },
        {
          icon: "info",
          tooltip: t("profile_page_subtitle"),
          onClick: (event, rowData) => {
            navigate( `/users/driverdetails/${rowData.id}`,  { state: { pageNo: currentPage }} )
          },
        },
        (rowData) => ({
          icon: () => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                padding: 10,
                backgroundColor: colors.MAIN_COLOR,
                borderRadius: 5,
                boxShadow: "0px 3px 5px 0px #B4B4B3",
              }}
            >
              <Typography style={{ color: colors.WHITE }}>
                {t("documents")}
              </Typography>
            </div>
          ),
          tooltip: t("documents"),
          onClick: () => 
          navigate(`/users/userdocuments/${id}/${rowData.id}`,  { state: { pageNo: currentPage }} )
        }),
      ]}
    />
    :<BlankTable  title={t('drivers')}  columns={columns}  data={[]} options={options}
    localization={localization}  
    actions={[   
      {
        icon: "add",
        tooltip: t("add_driver"),
        isFreeAction: true,
        onClick: (event) => 
        navigate( `/users/adddriver`,  { state: { pageNo: currentPage }} )
      },
    ]}
  />}
    <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    <Dialog open={rejectDialogOpen} onClose={() => setRejectDialogOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>{t('reject_account') || 'Reject Account'}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth style={{ marginTop: 20 }}>
          <InputLabel id="reject-reason-label">{t('rejection_reason') || 'Rejection Reason'}</InputLabel>
          <Select
            labelId="reject-reason-label"
            multiple
            value={rejectReasons}
            input={<OutlinedInput label={t('rejection_reason') || 'Rejection Reason'} />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={t(value, value)} size="small" />
                ))}
              </Box>
            )}
            onChange={(e) => {
              const { target: { value } } = e;
              setRejectReasons(
                typeof value === 'string' ? value.split(',') : value,
              );
            }}
          >
            {REJECTION_KEYS.map((key) => (
              <MenuItem key={key} value={key}>
                <Checkbox checked={rejectReasons.indexOf(key) > -1} />
                <ListItemText primary={t(key)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={() => setRejectDialogOpen(false)} variant="outlined" style={{ color: colors.MAIN_COLOR, borderColor: colors.MAIN_COLOR, borderRadius: 8 }}>
          {t('cancel')}
        </Button>
        <Button
          onClick={handleRejectAccount}
          variant="contained"
          disabled={rejectReasons.length === 0}
          style={{
            backgroundColor: rejectReasons.length > 0 ? colors.RED : '#e0e0e0',
            color: rejectReasons.length > 0 ? '#fff' : '#a0a0a0',
            borderRadius: 8,
            fontWeight: 'bold',
            boxShadow: rejectReasons.length > 0 ? '0px 2px 4px rgba(255, 30, 29, 0.3)' : 'none'
          }}
        >
          {t('reject') || 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>
  </div>
  );
}
